const data = [
  {
    name: "Social Connektt...: A Social Media Website",
    description:
      "Social Connektt.. is a type of Scoial Media Website which includes new Profile creation with profile picture,Bio,location and the posts.And also you can see others profile and their posts in the website. Technology Stack Used in this project is React js,Node js,Express js,MongoDB,Rest Api's And Material Ui. Note: This website may not be responsive because this project is maily focused on its functionality. ",
    github: "https://github.com/Vinaykumar2226/Social-Media-Frontend",
    liveLink: "https://social-conekktt.onrender.com/",
    year: 2024,
    type: "Solo",
    techStack:
      "React js,Node js,MongoDB,Express js,Github,Rest API's,Material UI",
    image: "social-connektt.png",
  },
  {
    name: "TechieMitra : Mobile Application",
    description:
      "TECHIEMITRA(Connecting Service seeker & Service provider) as the name goes is an advance yet highly promising system helping a service seeker to get accurate and best technician in their city in no time.This System is an cross platform Mobile Application which works on both the android and ios device and it is developed in visual studio code editor .The technologies used in developing this application are nodejs , React Native ,PostgreSQL,Supabase.",
    github: "https://github.com/Vinaykumar2226/TechieMitra-Mobile-Application-",
    liveLink:
      "https://github.com/Vinaykumar2226/TechieMitra-Mobile-Application-",
    year: 2023,
    type: "Solo",
    techStack: "React Native,PostgreSQL,Node js,Supabase,",
    image: "TechieMitra.png",
  },
  {
    name: "Weather Forecast Application",
    description:
      "Weather Forecast is an web page Which helps the users to see the Weather Forecast for 7 days By default the location is set to Hyderabad If you want to search your city's weather ,enter your city name properly and search. If city found it returns the weather forecast of 7 days, else shows error. It displays the data like Temperature,Humidity and Windspeed.It is an responsive webpage built by using 1.HTML 2.CSS 3.JAVASCRIPT 4.Bootstrap 5.Weather API",
    github: "https://github.com/Vinaykumar2226/Weather-Forecast-Application",
    liveLink: "https://vinaykumar2226.github.io/Weathter-forecast-link/",
    year: "2022",
    type: "Solo",
    techStack: "Html,Css,Javascript,Weather API.",
    image: "Weather-forecast.png",
  },
];
export default data;
